import type { FC } from "react"
import React from "react"
import { Stack } from "@chakra-ui/react"

import type { ChainId, ExecutableCall } from "query/graphql"
import ProposalCommand from "proposal/components/ProposalCommand"
import { generateArrayOfNumbers } from "common/helpers/array"

type Props = {
  chainId: ChainId
  executableCalls: ExecutableCall[]
}

const ProposalExecutableCode: FC<Props> = ({ chainId, executableCalls }) => {
  const calldatas = executableCalls?.map((call) => call.calldata)
  const targets = executableCalls?.map((call) => call.target)
  const values = executableCalls?.map((call) => call.value)

  return (
    <Stack className="scrollbar" spacing={4}>
      {generateArrayOfNumbers(calldatas.length).map((index) => {
        const executableCall = executableCalls?.[index]

        const signature = executableCall?.signature || undefined

        return (
          <ProposalCommand
            key={`${calldatas[index]}-${index}`}
            calldata={calldatas[index]}
            chainId={chainId}
            index={index}
            signature={signature}
            target={targets[index]}
            value={values[index]}
          />
        )
      })}
    </Stack>
  )
}

export default ProposalExecutableCode
